import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
	UserPoolId: "eu-central-1_RcxcXmqmB",
	ClientId: "5ahn80hbha3ngja0nc8251msld",
};

export default new CognitoUserPool(poolData);
